import React from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import ChatAgent from './components/ChatAgent/ChatAgent'
import Home from './components/Home/Home'
import Privacy from './components/Privacy/Privacy' // Страница Политика конфиденциальности
import Terms from './components/Terms/Terms' // Страница Условия и положения
import './global.css'

function App() {
	return (
		<Router>
			<Routes>
				<Route path='/' element={<Home />} />
				<Route path='/terms' element={<Terms />} />{' '}
				{/* Маршрут для страницы Условия и положения */}
				<Route path='/privacy' element={<Privacy />} />{' '}
				{/* Маршрут для страницы Политика конфиденциальности */}
				<Route path='/chat-agent-qwerty123' element={<ChatAgent />} />{' '}
				{/* Маршрут для страницы регистрации бизнеса */}
			</Routes>
		</Router>
	)
}

export default App
